import { render, staticRenderFns } from "./FormInputDropdownCustomerType.vue?vue&type=template&id=5965cc60&scoped=true"
import script from "./FormInputDropdownCustomerType.vue?vue&type=script&lang=js"
export * from "./FormInputDropdownCustomerType.vue?vue&type=script&lang=js"
import style0 from "./FormInputDropdownCustomerType.vue?vue&type=style&index=0&id=5965cc60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5965cc60",
  null
  
)

export default component.exports